import React,{ Component } from 'react';
import {
  Container
} from 'reactstrap';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import OnboardingNavBar from './OnboardingNavBar';
import OnboardingHiImMary from '../../OnboardingHiImMary';
import OnboardingSignup from '../../OnboardingSignup';
import OnboardingDemo from '../../OnboardingDemo';
import OnboardingTutorial from '../../OnboardingTutorial';
import Help from '../../Help';
import VersionTag from '../../../shared/components/VersionTag';

import { ACTIVE_PROFILE } from '../../../config';

class OnboardingPortal extends Component {
  isNavHidden(){
    const { location } = this.props;

    return location.pathname === '/welcome/signup'
      || location.pathname === '/welcome/demo'
      || location.pathname === '/welcome/tutorial/setup'
      || location.pathname === '/welcome/tutorial'
      || location.pathname === '/invite/signup'
      || location.pathname === '/invite/demo';
  }

  getCurrentStep(){
    const { location } = this.props;

    if(location.pathname.indexOf('create') >= 0){
      return 1;
    } else if(location.pathname.indexOf('audience') >= 1){
      return 2;
    } else if(location.pathname.indexOf('payment') >= 1){
      return 3;
    } else if(location.pathname.indexOf('review') >= 1){
      return 4;
    } else if(location.pathname.indexOf('success') >= 1){
      return 5;
    } else {
      return 0;
    }
  }

  render(){
    const { 
      match ,
      location, 
      environment,
      frontEndVersion,
      backEndVersion 
    } = this.props;

    return (
      <div className='OnboardingPortal'>
        {ACTIVE_PROFILE !== 'prod' && ( 
          <VersionTag 
            environment={environment}
            frontend={frontEndVersion}
            backend={backEndVersion}
          /> 
          )}
        <OnboardingNavBar
          currentStep={this.getCurrentStep()}
          hidden={location.pathname ==='/welcome' || location.pathname === '/invite'}
          navHidden={this.isNavHidden()}
        />
        <Container>
          <Switch>
            <Route exact path={match.url} component={OnboardingHiImMary} />
            <Route exact path={`${match.url}/signup`} component={OnboardingSignup} />
            <Route exact path={`${match.url}/demo`} component={OnboardingDemo} />
            <Route exact path={`${match.url}/tutorial/setup`} component={OnboardingTutorial} />
            <Route exact path={`${match.url}/tutorial/success`} component={OnboardingTutorial} />
            <Route path={`${match.url}/tutorial/:campaignId`} component={OnboardingTutorial} />
            <Route path={`${match.url}/help`} component={Help} />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default OnboardingPortal;



// WEBPACK FOOTER //
// ./src/routes/OnboardingPortal/components/OnboardingPortal.js